/**
 * Created by mnaughton on 10/15/2015.
 */

/**
 * BaseListView.
 */
import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
import $ from "jquery";
import Field from "core/models/Field";
var _collectionCache = {};
var CACHE_TIMEOUT = 120000; //two minutes

function collectionCache(view, collectionInfo, force) {
  var key = collectionInfo.key;
  var loader = collectionInfo.loader;
  var field = collectionInfo.field;
  var cacheItem = _collectionCache[key];
  var deferred;

  function updateValues(collection, field, deferred) {
    collection(view, function (err, models) {
      if (err) {
        delete _collectionCache[key];
        return deferred.reject(err);
      }

      deferred.resolve(
        _.map(models, function (model) {
          return {
            value: model.id,
            text: field.getValue(model),
          };
        })
      );
    });
  }

  if (!cacheItem || cacheItem.updated - Date.now() >= CACHE_TIMEOUT || force) {
    cacheItem = cacheItem || {
      updated: Date.now(),
    };

    if (loader && field) {
      deferred = new $.Deferred();

      cacheItem.updated = Date.now();
      cacheItem.promise = deferred.promise();

      updateValues(loader, field, deferred);
    }
  }

  _collectionCache[key] = cacheItem;

  return cacheItem.promise;
}

export default BaseFieldView.extend({
  /**
   * An array of hashes to supply to `this.itemTemplate` while rendering.
   * @param {Array} items The array of input items. Each is an object with a `text` property and a `value` property.
   * @return {Array} The array of hashes. By default, this is a shallow clone of `items`.
   */
  serializeItems: function (items) {
    return items.slice();
  },

  /**
   * Inserts an item appropriately within this view's element.
   * @param {String} item The item to insert.
   */
  insertItem: function (item) {},

  /**
   * Renders the HTML for each item within the list.
   * @type Function
   */
  itemTemplate: null,

  /**
   * Initiates the loading of any additional data.
   * @return Promise Resolves with the items to send to `serialize` and the items to send to serializeItems, or rejects with an error message.
   */
  startLoad: function () {
    var fieldValues = this.field.get("values");
    var valueSource = this.field.get("valueSource");
    var self = this;
    var load = new $.Deferred();

    this.stopListening();

    if (_.isArray(fieldValues)) {
      this.listenTo(
        this.field,
        "change:values value-updated",
        _.debounce(function () {
          self.render();
        }, 250)
      );
      load.resolve(self.options, fieldValues);
    } else if (valueSource) {
      this.listenToOnce(this.field, "change:valueSource", this.render);
      collectionCache(self, valueSource)
        .done(function (valueList) {
          load.resolve(self.options, valueList);
        })
        .fail(function (err) {
          load.reject(err);
        });
    }

    return load.promise();
  },

  render: function () {
    if (!this.rendering) {
      this.rendering = true;

      var self = this;
      var load = (this.load = this.startLoad());

      if (load.state() == "pending") {
        this.$el.html(this.loadingTemplate(this.serialize()));
      }

      load
        .done(function (options, items) {
          self.$el.html(self.template(self.serialize(options)));

          _.each(
            self.serializeItems(items),
            function (item) {
              this.insertItem(this.itemTemplate(item));
            },
            self
          );
        })
        .fail(function (err) {
          self.$el.html(this.errorTemplate(err));
        })
        .always(function () {
          self.delegateEvents();
          self.postRender();

          if (!_.isUndefined(self.options.value)) {
            self.value = self.options.value;
          }

          self.rendering = false;
        });
    }
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/BaseListView.js
// module id = 100
// module chunks = 1